<template>
  <section class="block__commerciaux scrollY">
    
    <Navbar class="mobile"/>

    <!-- //TITLE MOBILE -->
    <div class="header mobile">
          <h1>Challenge commerciaux</h1>
    </div>
    <!-- //TITLE MOBILE -->


      <div class="content__commerciaux ">

        <div class="filter mobile">
            <div class="select__wrapper">
              <font-awesome-icon :icon="['far', 'chevron-down']" />
              <b-form-select v-model="selected" :options="options" class="select">
              </b-form-select>
            </div>

              <!-- <b-form-select v-model="selected" :options="options"></b-form-select> -->
              <date-range-picker
                  ref='picker'
                  opens='left'
                  :locale-data='localTrad'
                  :ranges = false
                  v-model="localTrad.dateRange"
              >
              </date-range-picker>
        </div>


        <!-- HEADER -->
        <b-breadcrumb :items="items" class="desktop"></b-breadcrumb>
        <div class="sep desktop"></div>
        <!-- HEADER -->

        <div class="header desktop">
          <h1>Challenge commerciaux</h1>
          <div class="filter">
              <div class="select__wrapper">
                <font-awesome-icon :icon="['far', 'chevron-down']" />
                <b-form-select v-model="selected" :options="options" class="select">
                </b-form-select>
              </div>

                <!-- <b-form-select v-model="selected" :options="options"></b-form-select> -->
                <date-range-picker
                    ref='picker'
                    opens='left'
                    :locale-data='localTrad'
                    :ranges = false
                    v-model="localTrad.dateRange"
                >
                </date-range-picker>
          </div>
        </div>


        <b-row class="content__card">
          <b-col sm='12' md="6">
            <cardChallengesCommercials
            title = 'Chiffre d’affaire AN personnalisé'
            subtitle = 'Chiffre d’affaire AN'
            startDate = '04/04/2020'
            endDate = "04/05/2020"
            objectiveNumber = "120 000"
            inprogress = "58 000"
            deadline = "60"
            state = "en cours"
            />
          </b-col>          
          <b-col sm='12' md="6">
            <cardChallengesCommercials
            title = 'Chiffre d’affaire AN personnalisé'
            subtitle = 'Chiffre d’affaire AN'
            startDate = '04/04/2020'
            endDate = "04/05/2020"
            objectiveNumber = "120 000"
            inprogress = "58 000"
            deadline = "60"
            state = "en cours"
            />
          </b-col>          
          <b-col sm='12' md="6">
            <cardChallengesCommercials
            title = 'Chiffre d’affaire AN personnalisé'
            subtitle = 'Chiffre d’affaire AN'
            startDate = '04/04/2020'
            endDate = "04/05/2020"
            objectiveNumber = "120 000"
            inprogress = "58 000"
            deadline = "60"
            state = "en cours"
            />
          </b-col>          
          <b-col sm='12' md="6">
            <cardChallengesCommercials
            title = 'Chiffre d’affaire AN personnalisé'
            subtitle = 'Chiffre d’affaire AN'
            startDate = '04/04/2020'
            endDate = "04/05/2020"
            objectiveNumber = "120 000"
            inprogress = "58 000"
            deadline = "60"
            state = "en cours"
            />
          </b-col>  
        </b-row>


      </div>
  </section>   
</template>


<script>
import { mapGetters } from 'vuex'
import DateRangePicker from 'vue2-daterange-picker'
import cardChallengesCommercials from '../../../module/card/CardChallengesCommercials'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Navbar from '../../../module/Navbar'


export default {
  name:"challengeCommerciaux",
    components:{ 
      cardChallengesCommercials,
      DateRangePicker,
      Navbar,
    }, 
    computed: {
      ...mapGetters([
        'getDestination',
      ])
    },
    data () {
      return {
        content:"",
        selected: null,
        options: [
          { value: null, text: 'Tous' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ],        
        items: [
          {
            text: 'Challenges',
            // href: '/admin/me/challenges'
            to: { name: 'challengesHome' }
          },
          {
            text: 'Challenges commerciaux',
            active: true
          }
        ],

        localTrad: { 
          firstDay: 0, 
          applyLabel: "Appliquer",
          cancelLabel: "Annuler",
          separator: ' : ',
          daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Dec'],
          dateRange: {
            startDate: '2020-08-10',
            endDate: '2020-12-28',
          },                    
          }        
      }
    },
    created (){
      this.content = this.getDestination;
    },    
    methods : {           
    }
};
</script>
